var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon && _vm.asSvg)?_c('simple-svg',{attrs:{"src":_vm.iconPath,"width":_vm.width,"height":_vm.height}}):(_vm.icon)?_c('img',{staticClass:"icon",attrs:{"src":_vm.iconPath}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }